// extracted by mini-css-extract-plugin
export var questionBox = "_8c-0";